// Phase 6 — Track B T-B5. Auth copy.
//
// Phrasing rules per blueprint §13.4 / §13.8:
//   - calm and direct; no exclamation marks
//   - no emoji in structural strings (button labels, section titles, errors)
//   - no trailing punctuation in button labels (sentence labels are fine)
//   - sentence case (not title case)
//
// Linter tests in shared/tests/copy/* enforce these invariants.

export const authCopy = {
  signIn: 'Sign in',
  signOut: 'Sign out',
  signInTitle: 'Sign in',
  signInSubtitle: 'Welcome back to DailyDeck.',
  emailLabel: 'Email',
  emailPlaceholder: 'you@example.com',
  passwordLabel: 'Password',
  signInSubmit: 'Sign in',
  signingIn: 'Signing in',
  signedOut: 'You have been signed out.',

  // Google OAuth — button label and error toasts
  continueWithGoogle: 'Continue with Google',
  googleErrorCancelled: 'Sign-in cancelled.',
  googleErrorState: 'Sign-in failed. Please try again.',
  googleErrorFailed: 'Sign-in failed. Please try again.',
  googleErrorNoEmail: "Couldn't get your email from Google. Please try again.",

  /**
   * Phase 7.1 — register screen copy. Calm, sentence case, no emoji, no
   * exclamation marks. Mirrors the tone of `signInTitle` / `signInSubtitle`.
   */
  register: {
    pageTitle: 'Create your account',
    subtitle: 'Set up DailyDeck for the first time. Single-account on-prem.',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    passwordConfirmLabel: 'Confirm password',
    submitButton: 'Create account',
    submittingButton: 'Creating',
    linkToLoginPrefix: 'Already have an account?',
    linkToLoginCta: 'Sign in',
    linkToRegisterPrefix: "Don't have an account?",
    linkToRegisterCta: 'Create one',
    emailAlreadyRegistered:
      'An account with this email already exists. Sign in instead.',
  },
} as const;
